module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "lumi-gallery"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-79b25ff4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LumiGallery.vue
// module id = 67
// module chunks = 0